import {
  Button,
  Modal,
  Card,
  Spin,
  Row,
  Col,
  Select,
  Space,
  Cascader,
  message,
  Table,
} from "antd";
import axios from "axios";
import { SearchOutlined, RestOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { cancelCodeOptions } from "../constant/CancelCodeOption";
import { getSchemaContractOptions } from "../constant/SchemaOption";
import { GET_SELECT_RE_PRINT, HEADERS_EXPORT_BEN } from "../../../API/apiUrls";
import dayjs from "dayjs";
import SelectDataForRePrint from "./SelectDataForRePrint";

const GetRoundForRePrint = ({ open, close }) => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const contractOptions = getSchemaContractOptions(userCompany);
  const [loading, setLoading] = useState(false);
  const [cancelCodeSelect, setCancelCodeSelect] = useState([]);
  const [forPaySelect, setForPaySelect] = useState(null);
  const [selectedGCode, setSelectedGCode] = useState(null);
  const [selectedContract, setSelectedContract] = useState(null);
  const [datePicker, setDatePicker] = useState(null);
  const [arrTableRound, setArrTableRound] = useState([]);
  const [arrData, setArrData] = useState([]);
  const [isModalDetailData, setIsModalDetailData] = useState(false);
  const [dataModal, setDataModal] = useState();

  useEffect(() => {
    loadSelectRoundRePrint();
  }, []);

  const loadSelectRoundRePrint = async () => {
    setLoading(true);
    try {
      const { data, status } = await axios.get(GET_SELECT_RE_PRINT, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (
        status !== 200 ||
        !data ||
        (Array.isArray(data) && data.length === 0)
      ) {
        message.warning("ไม่มีข้อมูล");
        return;
      }

      console.log("res data", data);
      setArrTableRound(handleFilterCompany(data));
      setArrData(handleFilterCompany(data));
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("API error:", status, serverMsg || error.message);
      message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterCompany = (data) => {
    const useData = (Array.isArray(data) ? data : []).filter((item) =>
      Number(userCompany) !== 3
        ? Number(item.company) === 1
        : Number(item.company) === 2
    );
    return useData;
  };

  const contractLabelByValue = useMemo(() => {
    return Object.fromEntries(
      (contractOptions ?? []).map((o) => [o.value, o.label])
    );
  }, [contractOptions]);

  const { forMap, gMap } = useMemo(() => {
    const fm = {}; // map: FORCODE -> label
    const gm = {}; // map: GCODE  -> label (ถ้า GCODE ซ้ำข้ามกลุ่ม ให้ดูตัวอย่างล่าง)
    cancelCodeOptions.forEach((parent) => {
      fm[parent.value] = parent.label;
      parent.children?.forEach((ch) => {
        gm[ch.value] = ch.label;
      });
    });
    return { forMap: fm, gMap: gm };
  }, []);

  const handlefilterData = () => {
    setLoading(true);

    console.log(
      "datePicker",
      datePicker ? dayjs(datePicker).format("YYYY-MM-DD") : null
    );
    console.log("selectedContract", selectedContract);
    console.log("forPaySelect", forPaySelect);
    console.log("selectedGCode", selectedGCode);

    const isSameDay = (a, b) =>
      !!a &&
      !!b &&
      dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");

    try {
      const rows = Array.isArray(arrData) ? arrData : [];

      const filtered = rows.filter((item) => {
        // 1) สัญญา
        const passType =
          !selectedContract || item.dataType === selectedContract.value;

        // 2) วันที่
        const passDate = !datePicker || isSameDay(item.docTime, datePicker);

        // 3) FOR/GCODE
        const wantFG = !!(forPaySelect && selectedGCode);
        const passFG =
          !wantFG ||
          (item.gcode === selectedGCode &&
            (item.forCode === forPaySelect ||
              // เลือก 116 ให้รวม 115 ด้วย
              (forPaySelect === "116" && item.forCode === "115")));

        return passType && passDate && passFG; // AND logic
      });

      if (filtered.length === 0) {
        message.error("ไม่พบข้อมูล");
      }

      const result = filtered.map((item, index) => ({
        ...item,
        key:
          item.id ??
          `${item.dataType}-${item.forCode}-${item.gcode}-${item.docTime}-${index}`,
      }));

      setArrTableRound(result);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    close(false);
  };

  const onCascaderChange = (value, selectedOptions) => {
    console.log("value", value);
    setCancelCodeSelect(value);
    const [forPay, gcode] = value || [];
    setForPaySelect(forPay);
    setSelectedGCode(gcode);
  };

  const handleClear = () => {
    setForPaySelect(null);
    setSelectedGCode(null);
    setSelectedContract(null);
    setDatePicker(null);
    setCancelCodeSelect([]);
  };

  const columnsSelectRoundRePrint = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "สัญญา",
      key: "dataType",
      align: "center",
      render: (_text, record) => contractLabelByValue[record?.dataType] ?? "-",
    },
    {
      title: "รอบวันที่",
      align: "center",
      render: (text, record) => (
        <>
          {record.docTime
            ? dayjs(record.docTime).add(543, "year").format("DD MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "F CODE / G CODE",
      align: "center",
      render: (_text, record) => (
        <>
          {gMap[record.gcode] ?? record.gcode}

          <br />
          {forMap[record.forCode] ?? record.forCode}
        </>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <>
          <Button
            color="cyan"
            variant="outlined"
            onClick={() => {
              setDataModal(record);
              setIsModalDetailData(true);
            }}
          >
            ดูข้อมูล
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        title="ค้นหาข้อมูล"
        name="getRoundForRePrint"
        open={open}
        onCancel={handleCancel}
        width={"auto"}
        footer={[
          <Button key="close" danger onClick={handleCancel}>
            ปิด
          </Button>,
        ]}
        style={{ padding: "20px" }}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Card>
            <Row>
              <Col
                span={"24"}
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                <Select
                  key={userCompany}
                  size="large"
                  style={{
                    minWidth: "auto",
                    marginRight: "10px",
                  }}
                  placeholder="เลือกสัญญา"
                  popupMatchSelectWidth={false}
                  labelInValue // ★ เปิดใช้
                  value={selectedContract} // ต้องเป็น object { value, label }
                  onChange={(obj) => setSelectedContract(obj ?? null)} // obj = { value, label }
                  options={contractOptions}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
                <Space size={16} style={{ marginRight: "10px" }}>
                  <ThaiDatePicker
                    value={datePicker}
                    onChange={setDatePicker}
                    size="large"
                  />
                </Space>

                <Cascader
                  value={cancelCodeSelect}
                  options={cancelCodeOptions}
                  onChange={onCascaderChange}
                  placeholder="เลือกประเภทข้อมูล"
                  allowClear
                  showSearch
                  size="large"
                  style={{
                    width: "auto",
                    marginRight: "10px",
                  }}
                />
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="large"
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontWeight: "bold",
                    background: "linear-gradient(135deg, #667eea, blue)",
                    border: "none",
                    marginRight: "10px",
                  }}
                  onClick={handlefilterData}
                  disabled={loading}
                >
                  ค้นหา
                </Button>
                <Button
                  icon={<RestOutlined />}
                  size="large"
                  onClick={handleClear}
                  type="default" // หรือ "dashed"
                  danger
                  disabled={loading}
                >
                  ล้างข้อมูล
                </Button>
              </Col>
            </Row>
            <Row>
              <Col
                span={"24"}
                style={{ textAlign: "center", marginTop: "10px" }}
              >
                <Table
                  style={{ marginTop: "10px" }}
                  size="small"
                  columns={columnsSelectRoundRePrint}
                  dataSource={arrTableRound}
                  scroll={{ x: 850 }}
                  rowKey={(row) => row.key || row.id || row.DOCNO}
                  // footer={() => (
                  //   <p>จำนวนรอบที่บันทึก {arrayTable.length}</p>
                  // )}
                />
              </Col>
            </Row>
          </Card>
        </Spin>
      </Modal>
      {isModalDetailData ? (
        <SelectDataForRePrint
          open={isModalDetailData}
          close={setIsModalDetailData}
          dataRecord={dataModal}
        />
      ) : null}
    </>
  );
};
export default GetRoundForRePrint;
